import React from 'react';
import Link from '../../Router/Link';
import { ChevronRightIcon } from '../Icon';
import { Item as StyledItem, List } from './wrappers';
import { useTrackGenericEvent } from '../../hooks/tracking/useTrackingEvents';

interface IItem {
  name: string;
  path: string;
}

interface IBreadcrumbs {
  items: IItem[];
}

const Breadcrumbs = ({ items }: IBreadcrumbs) => (
  <List itemScope itemType="https://schema.org/BreadcrumbList">
    {items.map((item, index) => (
      <Item key={item.path} {...item} index={index} />
    ))}
  </List>
);

export default Breadcrumbs;

const clickEvent = { event: 'product_click_breadcrumb' };

interface IItemProps extends IItem {
  index: number;
}

const Item = ({ path, index, name }: IItemProps) => {
  const trackClick = useTrackGenericEvent(clickEvent);

  return (
    <StyledItem
      key={path}
      itemProp="itemListElement"
      itemScope
      itemType="https://schema.org/ListItem">
      <Link href={path} itemProp="item" onBeforeNavigate={trackClick}>
        <span itemProp="name">{name}</span>
        <meta itemProp="position" content={(index + 1).toString()} />
      </Link>
      <ChevronRightIcon strokeWidth="2" />
    </StyledItem>
  );
};
